import "../terms.css"
import React, { useState, useEffect } from 'react';
import UserStatus from './UserStatus';


const Terms = () => {

  useEffect(() => {
    document.title = "Terms and Conditions | TradeBarta.com";
  }, []);
  
  return (

    <div className="page-container">
      <div className="content-wrap">
      <section className="navbar-area navbar-one">
    <div className="container">
      <div className="row">
        <div className="col-lg-12">
          <nav className="navbar navbar-expand-lg">
            <a className="navbar-brand" href="/">
              <img width = "200" height = "70" src={require("../images/logo.png")} alt="Logo" />
            </a>

            <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarOne"
              aria-controls="navbarOne" aria-expanded="false" aria-label="Toggle navigation">
              <span className="toggler-icon"></span>
              <span className="toggler-icon"></span>
              <span className="toggler-icon"></span>
            </button>

            <div className="collapse navbar-collapse sub-menu-bar" id="navbarOne">
              <ul className="navbar-nav m-auto">
                <li className="nav-item">
                  <a className="active page-scroll" href="/">Home</a>
                </li>
                <li className="nav-item">
                  <a className="page-scroll" href="/pricing">Pricing</a>
                </li>
                
                <li className="nav-item">
                  <a className="page-scroll" href="/referral">Refer and Win</a>
                </li>
                <li className="nav-item">
                  <a className="page-scroll" href="/faq">FAQ</a>
                </li>
                <li className="nav-item">
                  <a className="page-scroll" href="/contact">Contact Us</a>
                </li>
                
              </ul>
            </div>
        
          <div className="navbar-btn">
                  <UserStatus />      
          </div>
      </nav>
        </div>
      </div>
    </div>
  </section>
<div
  className="form-container"
  style={{
    maxWidth: '800px',
    margin: '0 auto',
    textAlign: 'left',
    padding: '20px',
    backgroundColor: '#ffffff',
    borderRadius: '8px',
    boxShadow: '0 4px 10px rgba(0, 0, 0, 0.05)'
  }}
>
  <h1 style={{marginTop: '130px', marginBottom: '40px', textAlign: 'center' }}>
    Terms and Conditions
  </h1>
      <h2>1. Overview of the Service</h2>
      <p>TradeBarta provides stock investors with:</p>
      <ul>
        <li>SMS / Telegram alerts for stock price thresholds</li>
        <li>Optional news updates on Telegram from verified sources</li>
        <li>Free trial for 14 days followed by paid subscription plans</li>
      </ul>

      <h2>2. Free Trial and Subscription</h2>
      <ul>
        <li>Users receive a 14-day free trial upon signup</li>
        <li>Users will receive only Telegram notifications under free plan</li>
        <li>Subscriptions can be upgraded anytime</li>
        <li>Payments are processed by a third-party payment gateway</li>
        <li><strong>No refunds</strong> after a successful subscription</li>
      </ul>

      <h2>3. User Responsibilities</h2>
      <ul>
        <li>Provide accurate signup details</li>
        <li>Maintain account confidentiality</li>
        <li>Use the service legally and responsibly</li>
      </ul>

      <h2>4. Communication and Alerts</h2>
      <p>We are not liable for missed or delayed alerts due to network issues or carrier failures.</p>

      <h2>5. News and Market Data</h2>
      <p>News is sourced from verified third parties.</p>

      <h2>6. Payments and Billing</h2>
      <p>Payments are processed via a third-party payment gateway. All successful sales are final and non-refundable.</p>
      <p>Any failure in payment at third-party payment gateway in use will be settled by them as per their policy.</p>

      <h2>7. Termination</h2>
      <p>We may suspend accounts violating our terms or policies.</p>

      <h2>8. Limitation of Liability</h2>
      <p>We are not responsible for any loss due to failed alerts or inaccurate data.</p>

      <h2>9. Changes to Offerings and Terms</h2>
      <p>We may revise our offerings and these terms at any time. Continued use constitutes acceptance.</p>

      <h2>10. Contact</h2>
      <p>Email us at <a href="mailto:support@tradebarta.com">support@tradebarta.com</a>.</p>
          </div>
</div>       
<section className="footer-area footer-five">
  <div className="container">
    <div className="footer-top-content">
      
      {/* Links Section */}
      <div className="footer-links">
        <ul>
          <li>
            <a href="/terms" target="_blank" rel="noopener noreferrer">
              Terms & Conditions
            </a>
          </li>
          <li>
            <a href="/privacy" target="_blank" rel="noopener noreferrer">
              Privacy Policy
            </a>
          </li>
        </ul>
      </div>

      {/* Contact Section */}
      <div className="footer-contact">
        <h4>Contact Us:</h4>
        <a href="mailto:support@tradebarta.com">support@tradebarta.com</a>
      </div>

    </div>
  </div>

  {/* Bottom copyright section */}
  <div className="footer-copyright">
    <div className="container">
      <p className="text-center">Copyright © 2025. All Rights Reserved</p>
    </div>
  </div>
</section>
</div>
  );
};

export default Terms;
